import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: indent,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  avatar: {
    height: 40,
    width: 40,
    borderRadius: 20,
  },
  informationContainer: {
    flex: 1,
    marginLeft: 16,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  name: {
    height: 14,
    width: '70%',
    marginBottom: 6,
  },
  rank: {
    height: 14,
    width: '60%',
    marginBottom: 6,
  },
  sponsoredDate: {
    height: 14,
    width: '40%',
    marginBottom: 6,
  },
});
